/* eslint-disable camelcase */
import React, { useState, useEffect } from "react";
import moment from "moment";
import HolidayContainer from "../../containers/Holiday";
import * as style from "./styles.module.scss";
import history from "../../history";
import HolidayRequest from "../HolidayRequest";
import HolidayHistory from "../HolidayHistory";

const Holiday = () => {
  const [holidayRequest, setHolidayRequest] = useState(false);
  const [holidayHistory, setHolidayHistory] = useState(false);
  const showDateOfLastFriday = () => {
    const isTodayFriday = moment().day() === 5; // if 5 that means Friday

    if (isTodayFriday) {
      const fridayUpdateTime = new Date().setHours(8, 30, 0, 0);
      const updateTime = moment(fridayUpdateTime);
      const todayTime = moment(new Date());
      // check if it is after 8:30
      if (updateTime.isBefore(todayTime)) {
        return updateTime.format("DD MMMM YYYY");
      }
      // if no, return previous Friday
      const previousFriday = moment().weekday(-2);
      return previousFriday.format("DD MMMM YYYY");
    }

    // if todays not friday, return last friday
    const previousFriday = moment().weekday(-2);
    return previousFriday.format("DD MMMM YYYY");
  };

  const openHolidayFAQ = () => {
    window.open(
      "https://www.hrgo.co.uk/books/temporary-workers-handbook/working-for-hr-go-recruitment/holiday",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const showHolidayRequest = (responsibleTeam) => {
    const excludedTeams = ["HEDC", "HEDE", "HEDH"];
    return !excludedTeams.includes(responsibleTeam);
  };
  return (
    <HolidayContainer>
      {({
        holidayData,
        holidayHistoryData,
        firstName,
        lastName,
        candidateRef,
        postHolidayRequestFormFunc,
        holidayRequestFormLoading,
        holidayRequestFormSubmitted,
        permissions,
        responsibleTeam,
        errors,
      }) => {
        const checkProgress = () =>
          (holidayData[0]["Days Holiday Paid"] /
            holidayData[0]["Days Holiday Accrued"]) *
          100;
        return (
          <div className="container pt-1 pb-1">
            <div>
              <div>
                <h2>
                  Holiday report for {firstName} {lastName}
                </h2>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex flex-column">
                    <h5>
                      The data shown below is correct as of Friday,{" "}
                      {showDateOfLastFriday()}
                    </h5>
                  </div>
                  <div className="pb-1 d-flex flex-wrap justify-content-end">
                    <button
                      className={`btn btn-info ${
                        showHolidayRequest(responsibleTeam) ? "mr-lg-1" : ""
                      } mt-1`}
                      onClick={openHolidayFAQ}
                    >
                      Holiday FAQ
                    </button>
                    {showHolidayRequest(responsibleTeam) && (
                      <button
                        onClick={() => {
                          setHolidayRequest(false);
                          setHolidayHistory((value) => !value);
                        }}
                        className="btn btn-secondary mt-1 mr-lg-1"
                      >
                        Holiday History
                        <img
                          style={{
                            margin: "8px 0px 8px 8px",
                            filter:
                              "invert(100%) sepia(0%) saturate(0%) hue-rotate(168deg) brightness(107%) contrast(200%)",
                          }}
                          src="https://www.hrgo.co.uk/images/nav/nav-arrow-down.svg"
                          className={`${style.btn_arrow} ${
                            holidayHistory && style.active
                          }`}
                          width="12px"
                          height="12px"
                        />
                      </button>
                    )}
                    {showHolidayRequest(responsibleTeam) && (
                      <button
                        onClick={() => {
                          setHolidayHistory(false);
                          setHolidayRequest((value) => !value);
                        }}
                        className="btn btn-secondary mt-1"
                      >
                        Request Holiday
                        <img
                          style={{
                            margin: "8px 0px 8px 8px",
                            filter:
                              "invert(100%) sepia(0%) saturate(0%) hue-rotate(168deg) brightness(107%) contrast(200%)",
                          }}
                          src="https://www.hrgo.co.uk/images/nav/nav-arrow-down.svg"
                          className={`${style.btn_arrow} ${
                            holidayRequest && style.active
                          }`}
                          width="12px"
                          height="12px"
                        />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div>
              {holidayRequest && (
                <HolidayRequest
                  postHolidayRequestForm={postHolidayRequestFormFunc}
                  holidayData={holidayData}
                  holidayRequestFormLoading={holidayRequestFormLoading}
                  holidayRequestFormSubmitted={holidayRequestFormSubmitted}
                  permissions={permissions}
                  errors={errors}
                />
              )}
              {holidayHistory && (
                <HolidayHistory holidayHistoryData={holidayHistoryData} />
              )}
            </div>
            <div className={"container"}>
              <div className="row">
                <div className={`col-sm-6 ${style.cardStylesBottom}`}>
                  <div style={{ backgroundColor: "#DCDCDC" }}>
                    <div className="card-body">
                      <h5 className="card-title">Holiday Accrued (Days)</h5>
                      <p className={`card-text ${style.cardText}`}>
                        {(
                          Math.floor(
                            holidayData[0]["Days Holiday Accrued"] * 100
                          ) / 100
                        ).toFixed(2)}
                      </p>
                    </div>
                  </div>
                </div>
                <div className={`col-sm-6 ${style.cardStylesBottom}`}>
                  <div style={{ backgroundColor: "#DCDCDC" }}>
                    <div className="card-body">
                      <h5 className="card-title">Holiday Anniversary Date</h5>
                      <p className={`card-text ${style.cardText}`}>
                        {moment(holidayData[0]["Anniversary Date"]).format(
                          "DD/MM/YYYY"
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className={`col-sm-12 ${style.cardStylesMiddle}`}>
                  <div style={{ backgroundColor: "#F5F5F5" }}>
                    <div className="card-body">
                      <div
                        style={{
                          height: "20px",
                          backgroundColor: "lightgreen",
                        }}
                        className="progress"
                      >
                        <div
                          style={{
                            height: "20px",
                            backgroundColor: "lightcoral",
                            width: `${checkProgress()}%`,
                          }}
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={checkProgress()}
                          aria-valuemin={0}
                          aria-valuemax={100}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginTop: "10px",
                          }}
                        >
                          <h5>Holiday Taken (Days)</h5>
                          <div style={{ fontSize: "36px" }}>
                            {(
                              Math.floor(
                                holidayData[0]["Days Holiday Paid"] * 100
                              ) / 100
                            ).toFixed(2)}
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginTop: "10px",
                          }}
                        >
                          <h5
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              textAlign: "right",
                            }}
                          >
                            Holiday Remaining (Days)
                          </h5>
                          <div
                            style={{
                              fontSize: "36px",
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            {(
                              Math.floor(
                                holidayData[0]["Days Holiday Available"] * 100
                              ) / 100
                            ).toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: "20px" }} className="row">
                <div className={`col-sm-6 ${style.cardStyles}`}>
                  <div style={{ backgroundColor: "#DCDCDC" }}>
                    <div className="card-body">
                      <h5 className="card-title">Holiday Day Rate</h5>
                      <p className={`card-text ${style.cardText}`}>
                        £
                        {holidayData[0]["Override Rate Per Day"] !== 0
                          ? (
                              Math.floor(
                                holidayData[0]["Override Rate Per Day"] * 100
                              ) / 100
                            ).toFixed(2)
                          : (
                              Math.floor(holidayData[0]["Rate Per Day"] * 100) /
                              100
                            ).toFixed(2)}
                      </p>
                    </div>
                  </div>
                </div>
                <div className={`col-sm-6 ${style.cardStyles}`}>
                  <div style={{ backgroundColor: "#DCDCDC" }}>
                    <div className="card-body">
                      <h5 className="card-title">
                        {" "}
                        Total Holiday Pay Available
                      </h5>
                      <p className={`card-text ${style.cardText}`}>
                        £
                        {holidayData[0]["Override Rate Per Day"] !== 0
                          ? (
                              Math.floor(
                                holidayData[0]["Total Override Pay Available"] *
                                  100
                              ) / 100
                            ).toFixed(2)
                          : (
                              Math.floor(
                                holidayData[0]["Total Pay Available"] * 100
                              ) / 100
                            ).toFixed(2)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h6>
              Your holiday begins accruing from your first working day.
              <br />
              All holiday accrued should be taken within a year of your start
              date and should not be carried over to the following year.
              <br />
              In order to take your accrued holiday, please request to book
              holiday days using the form above. When your assignment ends, any
              accrued but untaken holiday will be processed.
              <br />
              The accrual rate is based on your average hours in a working week
              and a day rate based on your average earnings.
              <br />
              <br />
              Please note that the above report will not be updated to reflect
              your approved holiday until your holiday has been processed and
              paid to you.
              <br />
              Please bear in mind therefore when booking holiday for future
              dates that your Holiday Remaining days are only reflective of the
              current date and not of any holiday that has been approved but not
              taken yet.
              <br />
              <br />
              For any queries with your holiday, please contact our Customer
              Success team, <br /> Monday - Friday between 9am - 5.30pm on 01233
              515169 or via email at{" "}
              <a href="mailto:customer.success@hrgo.co.uk">
                customer.success@hrgo.co.uk
              </a>
            </h6>
            <div className="pt-2 pb-2 d-flex justify-content-end">
              <button
                onClick={() => history.push("/profile")}
                className="btn btn-primary"
              >
                Back to My Account
              </button>
            </div>
          </div>
        );
      }}
    </HolidayContainer>
  );
};

export default Holiday;
